<script lang="ts">
  import Icon from './Icon.svelte';

  let { status }: { status: boolean } = $props();
</script>

<span class="open-badge" class:open-badge--open={status} class:open-badge--closed={!status}>
  <Icon name={status ? 'check' : 'x'} size={12} strokeWidth={3} />
  <span>{status ? 'Open now' : 'Closed now'}</span>
</span>

<style>
  .open-badge {
    position: absolute;
    bottom: 0.75rem;
    left: 0.75rem;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 28px;
    padding: 0 0.625rem;
    border-radius: 9999px;
    color: #ffffff;
    font: inherit;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    backdrop-filter: blur(4px);
  }
  .open-badge--open { background: var(--color-dot-mint); }
  /* Distinct from --color-error (the muted brand destructive used
     for delete-style actions) — a status pill on a photo needs more
     pop to read at a glance. */
  .open-badge--closed { background: var(--color-status-closed); }
</style>
